import AccountSettings from './AccountSettings.container';

export default AccountSettings;
